export default __webpack_public_path__ + "static/media/logo-masihiy-white.dbe40069.png";